import { useEffect } from "react";
import type { PlayerResponse } from "@softmax/observatory-client/types";
import type { AccountUser } from "../account.types";
import { useAccountWrites } from "./use-account-writes";
import { useProfileEditor } from "./use-profile-editor";
import { useAgentEditor } from "./use-agent-editor";

export function useProfileSettings({
  savedUser,
  agents,
}: {
  savedUser: AccountUser;
  agents: PlayerResponse[];
}) {
  const writes = useAccountWrites();
  const profile = useProfileEditor({ savedUser, writes });
  const players = useAgentEditor({ agents, writes });
  const unsaved =
    writes.busy || writes.uncertain || profile.unsaved || players.unsaved;
  useEffect(() => {
    if (!unsaved) return;

    function onBeforeUnload(event: BeforeUnloadEvent) {
      event.preventDefault();
      event.returnValue = "";
    }
    window.addEventListener("beforeunload", onBeforeUnload);
    return () => window.removeEventListener("beforeunload", onBeforeUnload);
  }, [unsaved]);
  return { writes, profile, players };
}

type ProfileSettingsController = ReturnType<typeof useProfileSettings>;

export type ProfileEditorProps = { editor: ProfileSettingsController };
